import cepPromise from 'cep-promise';

export type CepPromiseResponse = {
  cep: string;
  state: string;
  city: string;
  neighborhood: string;
  street: string;
  service: string;
};

export const searchCep = async (cep: string): Promise<CepPromiseResponse> => {
  const cleanCep = cep.replace(/\D/g, '');

  if (cleanCep.length !== 8) {
    throw new Error('CEP must contain 8 digits');
  }

  const result = await cepPromise(cleanCep);
  return result;
};

export { cepPromise };
